import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-elegant-loader',
  templateUrl: './elegant-loader.component.html',
  styleUrls: ['./elegant-loader.component.scss']
})
export class ElegantLoaderComponent {
  @Input() loadingText: string = 'Loading...';
  @Input() id: string = '';
}
